<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_vii"></a>CONTENTS</h2>
<p class="toc-1a"><a href="#/xhtml/acknowledgments">ACKNOWLEDGMENTS</a></p>
<p class="toc"><a href="#/xhtml/names_and_relationships">NAMES AND RELATIONSHIPS</a></p>
<p class="toc-1"><a href="#/xhtml/prologue">PROLOGUE: Welcome to Khar Yalla</a></p>
<p class="nospace"> </p>
<p class="toc-fm"><a href="#/xhtml/chapter_001">1. Global Senegal</a></p>
<p class="toc-fm"><span href="#/xhtml/chapter_002" title="Link target outside of Sample">2. Homes and Their Histories</span></p>
<p class="toc-fm"><span href="#/xhtml/chapter_003" title="Link target outside of Sample">3. The Promise of Paradise</span></p>
<p class="toc-fm"><span href="#/xhtml/chapter_004" title="Link target outside of Sample">4. A Tale of Two Sisters</span></p>
<p class="toc-fm"><span href="#/xhtml/chapter_005" title="Link target outside of Sample">5. A Lamb Slaughtered</span></p>
<p class="toc-fm"><span href="#/xhtml/chapter_006" title="Link target outside of Sample">6. Home Economics</span></p>
<p class="toc-fm"><span href="#/xhtml/chapter_007" title="Link target outside of Sample">7. Only Trouble</span></p>
<p class="toc-1"><span href="#/xhtml/epilogue" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="toc-1"><span href="#/xhtml/glossary" title="Link target outside of Sample">GLOSSARY</span></p>
<p class="toc"><span href="#/xhtml/notes" title="Link target outside of Sample">NOTES</span></p>
<p class="toc"><span href="#/xhtml/references" title="Link target outside of Sample">REFERENCES</span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a5b04d28